import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">

        <div className="footer-col footer-brand-col">
          <Link to="/" className="footer-brand">Hercles</Link>
          <p className="footer-tagline">Your one-stop technology shop. Quality products, competitive prices, fast delivery.</p>
        </div>

        <div className="footer-col">
          <h4 className="footer-heading">Quick Links</h4>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/">Products</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/faq">FAQ</Link></li>
            <li><Link to="/shipping">Shipping</Link></li>
            <li><Link to="/returns">Returns</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4 className="footer-heading">Contact Us</h4>
          <ul className="footer-contact">
            <li><span>Nairobi, Kenya</span></li>
            <li><a href="tel:+254724474097">+254 724 474097</a></li>
            <li><a href="mailto:info@herclesglobal.com">info@herclesglobal.com</a></li>
            <li><span>Mon - Sat: 8 AM - 8 PM</span></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4 className="footer-heading">Get Support</h4>
          <div className="footer-socials">
            <a href="https://wa.me/254724474097" target="_blank" rel="noopener noreferrer" className="footer-social-btn">WhatsApp</a>
            <a href="mailto:info@herclesglobal.com" className="footer-social-btn">Email</a>
            <a href="tel:+254724474097" className="footer-social-btn">Call</a>
          </div>
        </div>

      </div>
      <div className="footer-bottom">
        <span>&copy; {new Date().getFullYear()} Hercles. All rights reserved.</span>
        <span className="footer-bottom-right">Built with love in Kenya</span>
      </div>
    </footer>
  );
}

export default Footer;
